import { render, staticRenderFns } from "./ProductReportList.vue?vue&type=template&id=050b5114&scoped=true"
import script from "./ProductReportList.vue?vue&type=script&lang=js"
export * from "./ProductReportList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/table-admin-styles.css?vue&type=style&index=0&id=050b5114&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b5114",
  null
  
)

export default component.exports